import router from '@/router'
import { adminPanelApi } from '@/services/adminPanelApi'
import {
  ADMIN_NOTIFICATIONS_UPDATED,
  resolveAdminNotificationRoute,
} from '@/utils/adminNotifications'
import {
  initAdminWebPushNotifications,
  unregisterAdminWebPushToken,
} from '@/services/webPushNotifications'

function navigateFromPushData(data = {}) {
  const route = resolveAdminNotificationRoute({
    redirectType: data.redirect_type,
    adId: Number(data.ad_id || 0) || null,
    vendorId: Number(data.vendor_id || 0) || null,
    companyId: Number(data.company_id || 0) || null,
    data,
  })

  if (route) {
    router.push(route).catch(() => {})
  }
}

export function setupAdminWebPush(vueInstance) {
  if (!localStorage.getItem('accessToken')) {
    return
  }

  initAdminWebPushNotifications({
    registerToken: payload => adminPanelApi.registerDeviceToken(payload),
    onForegroundMessage: () => {
      vueInstance.$root.$emit(ADMIN_NOTIFICATIONS_UPDATED, {})
    },
    onNotificationClick: data => {
      vueInstance.$root.$emit(ADMIN_NOTIFICATIONS_UPDATED, {})
      navigateFromPushData(data)
    },
  }).catch(() => {})
}

export function teardownAdminWebPush() {
  unregisterAdminWebPushToken(payload => adminPanelApi.removeDeviceToken(payload)).catch(() => {})
}
